export function useWishlistItemToggle(item: MaybeRefOrGetter<WishlistItem>) {
  const bookmarks = useBookmarks()
  const wishlist = useWishlist()

  const isBookmarked = computed(() => bookmarks.has(toValue(item).code))

  function toggle() {
    bookmarks.toggle(toValue(item).code)
  }

  function edit() {
    wishlist.edit(toValue(item))
  }

  return { isBookmarked, toggle, edit }
}
